import { useMemo, useState, useContext, useRef, Fragment } from 'react';

import { Image, Popover, message } from 'antd';

import CopyProductButton from './components/copyProductButton';
import OverseasPicture from './components/overseasPicture';
import { OverseasPriceLevel, OverseaDiscount } from './components/priceLevelAndDiscount';
import { OverseasProductTags } from './components/productTags';
import { addCartBall } from './components/purchaseButton';
import TotalPrice from './components/totalPrice';

import { cartAddOverseas, getMouseStock } from '@/apis/cart';
import { asyncCheckNoPriceEnquiry } from '@/apis/order';
import InputSelect from '@/components/InputSelect';
import LabelText from '@/components/LabelText';
import PriceInquiryModal from '@/components/PriceInquiryModal';
import SvgIcon from '@/components/SvgIcon';
import { LayoutContext } from '@/layouts/baseLayout/provider';
import { ProductItemContext } from '@/providers/productItem';
import { ProductListContext } from '@/providers/productList';
import useUserStore from '@/store/user';
import { buriedPoint, goItemBuriedPoint } from '@/utils/buriedPoint';
import lcMsgTips from '@/utils/lcMsgTips';
import Utils from '@/utils/Utils';

function OverseasItem(props) {
  const { productVO, dhAndTeAndRoCoupon, osCoupon, providerIndex, isMore, index, totalStockNumber } = props;

  const { resourceData, onlySScreen } = useContext(LayoutContext);
  const { searchResult } = useContext(ProductListContext);
  const { productVO: mainProductVO, index: mainProductIndex, newParameterCondition } = useContext(ProductItemContext);
  const { userInfo, updateUserInfo } = useUserStore();
  const [purchaseCount, setPurchaseCount] = useState(0);
  const [loading, setLoading] = useState(null);
  const [price, setPrice] = useState(0);
  const inputSelectRef = useRef(null);
  const addBtnRef = useRef(null);
  const [showPriceInquiryModal, setShowPriceInquiryModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [useInputCount, setUseInputCount] = useState('');

  const totalPrices = useMemo(() => {
    return Math.round(purchaseCount * price * 100) / 100;
  }, [purchaseCount, price, productVO]);

  // 跳转详情链接
  // 跳转详情链接
  const detailPage = useMemo(() => {
    if (Utils.isLcBook(productVO?.provider)) {
      const detailId = encodeURIComponent(encodeURIComponent(productVO?.productCodeProvider));
      let url = `${resourceData?.projectConfigVO?.lcscItemUrl}/details/${productVO?.provider}/${detailId}.html`;
      if (productVO?.track_zone) {
        url += `?fromZone=${Utils.safeEncodeURI(productVO?.track_zone)}`;
      }
      return url;
    } else {
      if (productVO?.canDetailsPage) {
        let detailId = productVO?.useSourcePartId ? productVO?.sourcePartId : productVO?.productCodeProvider;
        detailId = encodeURIComponent(encodeURIComponent(detailId));
        const providerAlias = encodeURIComponent(encodeURIComponent(productVO?.providerAlias));
        let url = `${resourceData?.projectConfigVO?.lcscItemUrl}/details/${providerAlias}/${detailId}.html`;
        if (productVO?.track_zone) {
          url += `?fromZone=${Utils.safeEncodeURI(productVO?.track_zone)}`;
        }
        return url;
      }
      return;
    }
  }, [resourceData, productVO]);

  const deliveryTimeWayDaysDom = useMemo(() => {
    let text = '';
    if (productVO?.deliveryTimeWayDays) {
      if (productVO?.stockNumber > 0) {
        text = productVO?.deliveryTimeWayDays?.replace(/(\d+)/g, '<strong class="font-bold">$&</strong>');
      } else {
        text = '待找料确认';
      }
    } else {
      return <></>;
    }
    return (
      <label
        className="mb-[6px] inline-block h-[18px] rounded-[3px] bg-[#EDEDED] px-[7px] leading-[18px] text-[#666]"
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      ></label>
    );
  }, [productVO]);

  function bookGoods() {
    if (productVO?.provider === 'mouser') {
      getMouseStock({
        provider: productVO?.provider,
        productModel: productVO?.productCodeProvider,
      }).then((res) => {
        if (res?.needLogin || res.msg === 'needLogin') {
          Utils.showWindowLogin();
        } else if (res.code === 405) {
          message.error(`${res?.msg}, 请重新加载！`);
        } else if (res?.code === 200) {
          addCart();
        }
      });
    } else {
      addCart();
    }
  }

  function addCart() {
    if (!inputSelectRef?.current?.validate(purchaseCount)) {
      return;
    }
    if (loading) {
      return;
    }
    setLoading(true);
    const { spm, lcsc_vid } = Utils.getButtonParams(addBtnRef.current);
    cartAddOverseas({
      purchaseNumber: purchaseCount / productVO?.theRatio,
      provider: productVO?.provider,
      productCodeProvider: productVO?.productCodeProvider,
      vendorCode: productVO?.vendorCode,
      batchNumber: productVO?.batchNumber,
      productRegion: productVO?.productRegion,
      placeOfOrigin: productVO?.placeOfOrigin,
      productCodeManufacturer: productVO?.productCodeManufacturer,
      sourcePartId: productVO?.sourcePartId,
      trackZone: productVO?.track_zone,
      lcscVid: lcsc_vid,
      spm,
    })
      .then((res) => {
        if (res?.shifting) {
          message.error(res.shifting);
        } else if (res?.needLogin || res?.msg === 'needLogin') {
          Utils.showWindowLogin();
        } else if (res?.code === 200) {
          message.success('加入购物车成功！');
          addCartBall(addBtnRef.current, () => {
            updateUserInfo({
              ...userInfo,
              cartNum: res?.result?.cart_contains_count,
            });
          });
        }
      })
      .finally(() => {
        setLoading(false);
        if (isMore) {
          buriedPoint({
            op: 'ADD_CART',
            data: {
              pc: mainProductVO?.productId,
              brand: isLcBook ? productVO?.brandName : productVO?.productGradePlateName,
              model: productVO?.productCodeManufacturer,
              kw: searchResult?.globalSearchKeyword,
              cp: searchResult?.currePage,
              ixz: mainProductIndex,
              ix: `${index}`.padStart(2, '0'),
              type: productVO?.provider,
              no: purchaseCount,
              price: totalPrices,
              kind: Utils.isLcBook(productVO?.provider) ? 'moreorder' : 'moreoversea',
              track_zone: productVO?.track_zone,
              parameter_condition: newParameterCondition,
            },
          });
        } else {
          buriedPoint({
            op: 'ADD_CART',
            data: {
              kw: searchResult?.globalSearchKeyword,
              xh: productVO?.productCodeManufacturer,
              brand: isLcBook ? productVO?.brandName : productVO?.productGradePlateName,
              model: productVO?.productCodeManufacturer,
              ix: 0,
              type: productVO?.provider,
              no: purchaseCount,
              price: totalPrices,
              kc: productVO?.stockNumber,
              kind: Utils.isLcBook(productVO?.provider) ? 'lcorder' : 'oversea',
              track_zone: productVO?.track_zone,
            },
          });
        }
      });
  }

  // 参数
  const paramMapDom = useMemo(() => {
    if (isMore) {
      if (productVO?.paramMap) {
        const list = Object.entries(productVO.paramMap).map(([key, value]) => {
          return `${key} : ${value}`;
        });
        const str = list.join('、');
        return <LabelText label="参数" text={str} title={str}></LabelText>;
      }
    } else {
      if (productVO?.selfParams) {
        const list = productVO.selfParams.map((item) => {
          return `${item?.parameterName} : ${item?.parameterDetailValue}`;
        });
        const str = list.join('、');
        return <LabelText label="参数" text={str} title={str}></LabelText>;
      }
    }
  }, [productVO, isMore]);

  function dataSheetClick() {
    buriedPoint({
      op: 'click_datasheet',
      data: {
        xh: productVO?.productCodeManufacturer,
        type: productVO?.provider,
        kw: searchResult?.globalSearchKeyword,
        brand: isLcBook ? productVO?.brandName : productVO?.productGradePlateName,
        model: productVO?.productCodeManufacturer,
      },
    });
  }

  function gotoItem(kind) {
    goItemBuriedPoint({
      kind,
      pc: mainProductVO?.productId,
      brand: isLcBook ? productVO?.brandName : productVO?.productGradePlateName,
      model: productVO?.productCodeManufacturer,
      kw: searchResult?.globalSearchKeyword,
      track_zone: productVO?.track_zone,
      type: productVO?.provider,
      cp: searchResult?.currePage,
      ix: providerIndex,
    });
  }

  const isLcBook = useMemo(() => Utils.isLcBook(productVO?.provider), [productVO?.provider]);

  const dataInfo = useMemo(() => {
    let productCode = productVO?.productCodeManufacturerHighlight || productVO?.productCodeManufacturer;
    if (isMore) {
      productCode = productVO?.productCodeManufacturer;
    }
    if (isLcBook) {
      return {
        productCode,
        brandName: productVO?.brandName,
        brandNameHighlight: productVO?.brandNameHighlight,
        standard: productVO?.selfStandard,
        standardHighlight: productVO?.selfStandardHighlight,
        productDesc: productVO?.selfProductIntro,
      };
    } else {
      return {
        productCode,
        brandName: productVO?.productGradePlateName,
        brandNameHighlight: productVO?.productGradePlateNameHighlight,
        standard: productVO?.selfStandard,
        standardHighlight: productVO?.selfStandardHighlight,
        productDesc: productVO?.productDesc,
      };
    }
  }, [productVO, isLcBook]);

  const changePriceInquiryModal = (value) => {
    setShowPriceInquiryModal(value);
  };

  const handleAskPrice = async () => {
    if (userInfo?.customerLogin !== 1) {
      Utils.showWindowLogin();
      return false;
    }
    let params;
    if (props?.productVO?.selfProductCode) {
      // 判断是否P转C
      params = {
        selfProductCode: props?.productVO?.selfProductCode,
        selfProductId: props?.productVO?.selfProductId,
        provider: props?.productVO?.lcBookProductVO?.provider,
        productCodeProvider: props?.productVO?.lcBookProductVO?.productCodeProvider,
        productCodeManufacturer: props?.productVO?.lcBookProductVO?.productCodeManufacturer,
        vendorCode: props?.productVO?.lcBookProductVO?.vendorCode,
      };
    } else if (props?.productVO?.provider) {
      // 存在provider即为订货或海外代购
      params = {
        provider: props?.productVO?.provider,
        productCodeProvider: props?.productVO?.productCodeProvider,
        productCodeManufacturer: props?.productVO?.productCodeManufacturer,
        vendorCode: props?.productVO?.vendorCode,
      };
    } else {
      // 现货
      params = {
        productId: props?.productVO?.productId,
        productCode: props?.productVO?.productCode,
      };
    }
    const res = await asyncCheckNoPriceEnquiry(params);
    if (res?.needLogin || res?.msg === 'needLogin') {
      Utils.showWindowLogin();
      return false;
    }
    if (res?.code === 200) {
      setCurrentItem(props?.productVO);
      changePriceInquiryModal(true);
    } else {
      lcMsgTips.showConfirmModal({
        title: res?.msg,
      });
    }
  };

  return (
    <>
      <div className={`flex p-[20px] leading-[18px]`}>
        <div>
          <div className="flex">
            <div className="w-[121px] h-[105px] select-none">
              <a
                data-spm="t"
                className="relative"
                aria-label="点击跳转详情"
                target="_blank"
                href={detailPage}
                onClick={() => gotoItem('picture')}
              >
                <OverseasPicture productVO={productVO} />
              </a>
            </div>
            <div className={Utils.addBigScreenClassName('w-[178px]', '_lg:w-[215px]', onlySScreen)}>
              <LabelText
                text={dataInfo?.productCode}
                title={dataInfo?.productCode}
                isTitle
                textBold
                link={detailPage}
                spm="n"
                bp="型号"
                onClick={() => gotoItem('name')}
              ></LabelText>
              <LabelText
                label="品牌"
                text={dataInfo?.brandNameHighlight || dataInfo?.brandName}
                title={dataInfo?.brandNameHighlight || dataInfo?.brandName}
              ></LabelText>
              {dataInfo?.standard && (
                <LabelText
                  label="封装"
                  text={dataInfo?.standardHighlight || dataInfo?.standard}
                  title={dataInfo?.standard}
                ></LabelText>
              )}
              {paramMapDom}
              {dataInfo?.productDesc && (
                <LabelText label="描述" text={dataInfo?.productDesc} title={dataInfo?.productDesc}></LabelText>
              )}
            </div>
            <div className={Utils.addBigScreenClassName('w-[190px]', '_lg:w-[233px]', onlySScreen)}>
              {productVO?.batchNumber && <LabelText label="批次" text={productVO?.batchNumber}></LabelText>}
              {productVO?.placeOfOrigin && <LabelText label="产地" text={productVO?.placeOfOrigin}></LabelText>}
              {productVO?.productRegion && <LabelText label="地区" text={productVO?.productRegion}></LabelText>}
              {productVO?.packagingList?.length > 0 && (
                <LabelText label="包装" text={productVO?.packagingList.join(' / ')}></LabelText>
              )}
              {productVO?.productCodeProvider && !isLcBook && (
                <LabelText label="供应商编号" text={productVO?.productCodeProvider}></LabelText>
              )}
              {isLcBook && productVO?.uploadTime && (
                <LabelText
                  label="更新时间"
                  text={Utils.dateFormat(productVO?.uploadTime, 'yyyy年MM月dd日')}
                ></LabelText>
              )}
            </div>
          </div>
          {!isMore && (
            <div className="flex flex-wrap items-center mt-[12px]">
              <div className="flex w-[115px] justify-end">
                {productVO?.bigImageUrl && (
                  <Popover
                    content={
                      <a href={productVO?.bigImageUrl} target="_blank">
                        <Image
                          width={180}
                          height={180}
                          src={productVO?.bigImageUrl}
                          preview={false}
                          style={{ objectFit: 'contain' }}
                          fallback="https://static.szlcsc.com/ecp/assets/web/static/images/default_pic.gif"
                        />
                      </a>
                    }
                    overlayClassName="lcsc-popover-wrapper"
                    placement="right"
                  >
                    <button className="mr-[10px] flex h-[26px] w-[95px] items-center justify-center rounded-[13px] bg-[#F5F6F9] text-[#333] hover:bg-[#ECEEF0]">
                      <SvgIcon app="so" iconName="search-icon" className="size-[15px] inline-block"></SvgIcon>
                      <span className="ml-[7px]">参考图片</span>
                    </button>
                  </Popover>
                )}
              </div>
              {productVO?.dataSheetUrl && (
                <a
                  className="mr-[10px] flex h-[26px] w-[95px] items-center justify-center rounded-[13px] bg-[#F5F6F9] text-[#333] hover:bg-[#ECEEF0] hover:text-[#333]"
                  href={productVO.dataSheetUrl}
                  target="__blank"
                  aria-label="数据手册"
                  onClick={dataSheetClick}
                >
                  <i className="mr-[5px] inline-block h-[18px] w-[17px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/so/pdf.svg)] bg-no-repeat"></i>
                  <span>数据手册</span>
                </a>
              )}
              <CopyProductButton
                {...props}
                detailPage={detailPage}
                providerAlias={productVO?.providerAlias}
              ></CopyProductButton>
            </div>
          )}
        </div>
        <div className={Utils.addBigScreenClassName('w-[157px]', '_lg:w-[180px]', onlySScreen)}>
          <OverseasProductTags productVO={productVO} dhAndTeAndRoCoupon={dhAndTeAndRoCoupon} osCoupon={osCoupon} />
        </div>
        <div className="flex flex-1 flex-col items-center">
          {productVO?.isShowPrice === false ? (
            <>需询价</>
          ) : (
            <>
              <OverseaDiscount {...productVO} />
              <OverseasPriceLevel
                discountTieredPrices={productVO?.discountTieredPrices}
                tieredPrices={productVO?.tieredPrices}
                purchaseCount={purchaseCount}
                onChange={setPrice}
              />
            </>
          )}
        </div>
        <div className={Utils.addBigScreenClassName('w-[161px]', '_lg:w-[186px]', onlySScreen)}>
          {deliveryTimeWayDaysDom}
          {productVO?.stockNumber > 0 && (
            <>
              <LabelText
                label="库存"
                text={isLcBook ? Utils.unitConversion(productVO?.stockNumber) : productVO?.stockNumber}
                textBold
              ></LabelText>
              {productVO?.incrementalQuantity && (
                <LabelText label="增量" text={productVO?.incrementalQuantity}></LabelText>
              )}
              {productVO?.productMinEncapsulationNumber && (
                <LabelText
                  label="最小包装"
                  text={`${productVO?.productMinEncapsulationNumber}${productVO?.unit}`}
                ></LabelText>
              )}
            </>
          )}
        </div>
        <div className={`${Utils.addBigScreenClassName('w-[120px]', '_lg:w-[140px]', onlySScreen)} text-right`}>
          <InputSelect
            ref={inputSelectRef}
            defaultCount={productVO?.minBuyNumber}
            defaultUnit={productVO?.unit}
            productUnit={productVO?.unit}
            minBuyNumber={productVO?.minBuyNumber}
            stockNumber={productVO?.stockNumber}
            theRatio={productVO?.theRatio}
            onChange={(value) => setPurchaseCount(value)}
            onChangeUseInputCount={(value) => setUseInputCount(value)}
          ></InputSelect>
          <TotalPrice totalPrices={totalPrices} isShowPrice={productVO?.isShowPrice}></TotalPrice>
          {productVO?.isShowPrice === false ? (
            <button
              className="mb-[6px] h-[32px] w-full rounded-[6px] text-[12px] border-[1px] border-solid border-[#1FA0E8] bg-[#EDF9FF] text-[#1FA0E8] hover:border-[#0093E6] hover:bg-[#0093E6] hover:text-[white]"
              onClick={handleAskPrice}
            >
              我要询价
            </button>
          ) : (
            <button
              ref={addBtnRef}
              className="mb-[6px] h-[32px] w-full rounded-[6px] bg-[#0093E6] text-[12px] text-[white] hover:bg-[#47B2ED]"
              onClick={bookGoods}
              data-spm="iad"
            >
              加入购物车
            </button>
          )}
        </div>
      </div>
      {showPriceInquiryModal && (
        <PriceInquiryModal
          showModal={showPriceInquiryModal}
          changeShowModal={changePriceInquiryModal}
          purchaseCount={useInputCount}
          currentItem={currentItem}
          totalStockNumber={totalStockNumber}
        />
      )}
    </>
  );
}

export default OverseasItem;
